/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: 'declare sub callback_stgcmd_buzz_command()',
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_stgcmd_buzz_command',
        template: `
sub callback_stgcmd_buzz_command()
'****callback_stgcmd_buzz_command****'
end sub
    `,
    });

    return blocks;
};
